import { isEmpty } from "lodash";
import store from "@/store";
import ProfileService from "@/services/profile";

/**
 * Loads what the portal's pages read from the store, as signing in does: the account, the
 * default profile (choosing one if there is none), the profiles and the tests. Returns whether
 * the account has a profile to show.
 *
 * A session can be signed in without any of this: signing in while the account was pending
 * deletion skips it, and the store is kept across page reloads, so a reload never fetches it.
 */
export const loadPortal = async () => {
    await store.dispatch("fetchAccount");
    await store.dispatch("fetchProfile");
    await store.dispatch("fetchAllProfiles");
    await loadTests("SET_ACCOUNT_TESTS");

    if (!hasProfile()) {
        // No default profile: pick one the way signing in does, a kit's before an upload's.
        const profiles = Object.values(store.getters.allProfiles || {});
        const first =
            profiles.find((p) => p.profile?.barcode?.startsWith("LD")) ||
            profiles.find((p) => p.profile?.barcode?.startsWith("LT")) ||
            profiles[0];
        if (!first?.permission?.id) {
            return false;
        }
        await ProfileService.setDefaultProfile(first.permission.id);
        await store.dispatch("fetchProfile");
    }

    await loadTests("SET_KIT_TESTS", store.getters.profile.profile.barcode);
    return hasProfile();
};

/** Loads the portal (see loadPortal) and opens the dashboard, or the activation screen if there is no profile. */
export const enterPortal = async (router) =>
    router.push({ name: (await loadPortal()) ? "dashboard" : "activation" });

/** The store starts with an empty {} profile, which is no profile. */
export const hasProfile = () => !isEmpty(store.getters.profile?.profile?.barcode);

// As when signing in, tests that fail to load are left for the pages to fetch again.
const loadTests = async (action, payload) => {
    try {
        await store.dispatch(action, payload);
    } catch (err) {
        console.error(`Could not load ${action}`, err);
    }
};
